import React from 'react';
import { PerfectScrollbar } from 'components/PerfectScrollbar';
import { InfiniteScroller } from '@src/components/InfiniteScroller';
import styles from './styles.module.scss';

interface IProps {
  title: string | React.ReactElement
  empty?: string
  isEmpty?: boolean
  children: any
  leftSection?: any
  collectionId?: string
  noMore?: boolean
  loadCollectionMedia?: () => Promise<void>
}

export function CollectionRow({
  title, empty, isEmpty, children, leftSection, noMore, loadCollectionMedia,
}: IProps) {
  return (
    <div className={`${styles.collectionRow} medias`} data-empty={isEmpty}>
      <div className="head">
        <div className="title">{title}</div>
        <div className="filters" />
      </div>
      <div className={styles.row}>
        {leftSection ? (
          <div className={styles.leftSection}>
            {leftSection}
          </div>
        ) : null}
        <InfiniteScroller
          container={(props, children) => (
            <PerfectScrollbar
              className={styles.bar}
              data-empty={isEmpty}
              options={{
                wheelSpeed: 0.6,
                minScrollbarLength: 30,
                maxScrollbarLength: 120,
                useBothWheelAxes: true,
                suppressScrollY: true,
              }}
              {...props}
            >
              {children}
            </PerfectScrollbar>
          )}
          noMore={noMore || false}
          threshold={1700}
          load={loadCollectionMedia || (async () => {})}
          horizontal
        >
          <div className="slide" data-empty={empty}>
            {children}
          </div>
        </InfiniteScroller>
      </div>
    </div>
  );
}
